<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('workSchedule.workSchedule') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('workSchedule.shift') }}</label>
              <ts-loading-banner :loading="ready_fetch">
                <ts-search-select
                  v-model.number="model.shift_id"
                  :options="shiftsOption"
                  :class="{ 'is-invalid': errors.has('shift_id') }"
                ></ts-search-select>
              </ts-loading-banner>
              <div
                class="invalid-feedback"
                v-if="errors.has('shift_id')"
              >{{ errors.first('shift_id') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('workSchedule.yearFrom') }}</label>
              <ts-date-picker-input
                :class="{ 'is-invalid': errors.has('cycle_year_from') }"
                format="YYYY"
                v-model="model.cycle_year_from"
              ></ts-date-picker-input>
              <div
                class="invalid-feedback"
                v-if="errors.has('cycle_year_from')"
              >{{ errors.first('cycle_year_from') }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label required"
              >{{ $t('workSchedule.monthFrom') }}</label>
              <ts-date-picker-input
                :class="{ 'is-invalid': errors.has('cycle_month_from') }"
                format="MM"
                v-model="model.cycle_month_from"
              ></ts-date-picker-input>
              <div
                class="invalid-feedback"
                v-if="errors.has('cycle_month_from')"
              >{{ errors.first('cycle_month_from') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('workSchedule.yearTo') }}</label>
              <ts-date-picker-input
                :class="{ 'is-invalid': errors.has('cycle_year_to') }"
                format="YYYY"
                v-model="model.cycle_year_to"
              ></ts-date-picker-input>
              <div
                class="invalid-feedback"
                v-if="errors.has('cycle_year_to')"
              >{{ errors.first('cycle_year_to') }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('workSchedule.monthTo') }}</label>
              <ts-date-picker-input
                :class="{ 'is-invalid': errors.has('cycle_month_to') }"
                format="MM"
                v-model="model.cycle_month_to"
              ></ts-date-picker-input>
              <div
                class="invalid-feedback"
                v-if="errors.has('cycle_month_to')"
              >{{ errors.first('cycle_month_to') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              class="btn-primary ml-2"
              :waiting="saving"
              @click.prevent="save"
              v-if="editData"
            >
              {{
              $t('button.save')
              }}
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'copy-work-schedule-form',
  props: ['editData'],
  data() {
    return {
      model: {
        shift_id: '',
        cycle_year_from: moment().format('YYYY'),
        cycle_month_from: moment()
          .add(-1, 'months')
          .format('MM'),
        cycle_year_to: moment().format('YYYY'),
        cycle_month_to: moment().format('MM')
      },
      errors: new Errors(),
      saving: false,
      ready_fetch: false
    }
  },
  created() {
    this.fetchDataBeforeCreate()
  },
  computed: {
    shiftsOption() {
      return this.$store.state.hr.workSchedule.shifts.map(el => ({
        value: el.shift_id,
        text: el.shift_name + ' (' + el.shift_type + ')'
      }))
    }
  },
  methods: {
    fetchDataBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('hr/workSchedule/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/workSchedule/save', this.model)
        .then(response => {
          return this.$store
            .dispatch('hr/workSchedule/fetch', {
              shift_id: this.model.shift_id,
              cycle_year: this.model.cycle_year_to,
              cycle_month: this.model.cycle_month_to
            })
            .then(res => {
              this.saving = false
              this.$emit('close')
              this.$toasted.success(response.message)
              return Promise.resolve(res)
            })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    clearInput() {
      this.model = {
        shift_id: '',
        cycle_year_from: moment().format('YYYY'),
        cycle_month_from: moment()
          .add(-1, 'months')
          .format('MM'),
        cycle_year_to: moment().format('YYYY'),
        cycle_month_to: moment().format('MM')
      }
    }
  }
}
</script>
